"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Label_1 = require("../Label");
var hooks_1 = require("../../hooks");
exports.Checkbox = react_1.default.forwardRef(function (props, ref) {
    var checked = props.checked, className = props.className, disabled = props.disabled, error = props.error, focus = props.focus, id = props.id, indeterminate = props.indeterminate, label = props.label, labelProps = props.labelProps, name = props.name, readonly = props.readonly, _a = props.size, size = _a === void 0 ? 'medium' : _a, value = props.value, onChange = props.onChange, onClick = props.onClick, tabIndex = props.tabIndex, rest = __rest(props, ["checked", "className", "disabled", "error", "focus", "id", "indeterminate", "label", "labelProps", "name", "readonly", "size", "value", "onChange", "onClick", "tabIndex"]);
    var labelRef = react_1.default.useRef(null);
    var newRef = react_1.default.useRef(null);
    var itemRef = ref ? ref : newRef;
    var isFocusVisible = hooks_1.useFocusVisible(itemRef).isFocusVisible;
    react_1.default.useEffect(function () {
        if (focus) {
            labelRef.current.focus();
        }
    }, [focus]);
    var onChangeHandler = function (e) {
        if (onChange) {
            onChange(value, e.currentTarget.checked, e);
        }
    };
    var onClickHandler = function (e) {
        if (onClick) {
            onClick(e, props);
        }
    };
    var handleClickEvent = function (e) {
        var target = e.target;
        if (target.tagName !== 'INPUT') {
            e.stopPropagation();
        }
    };
    var getLabel = function () {
        var _a;
        if (label === undefined || label === '')
            return false;
        var labelClassName = (_a = labelProps === null || labelProps === void 0 ? void 0 : labelProps.className) !== null && _a !== void 0 ? _a : null;
        var LabelClasses = classnames_1.default(labelClassName, 'Checkbox__label');
        return (react_1.default.createElement(Label_1.Label, __assign({ error: error, disabled: disabled }, labelProps, { className: LabelClasses }), label));
    };
    var CheckboxClasses = classnames_1.default('a-Checkbox', className, {
        'Checkbox--indeterminate': indeterminate,
        'Checkbox--disabled': disabled || readonly,
        'Checkbox--checked': checked,
        'Checkbox--error': error,
        'Checkbox--small': size === 'small',
        'Checkbox--large': size === 'large',
        'Checkbox--fitted': label === undefined || label === '',
        'Checkbox--focus-visible': isFocusVisible,
    });
    var indeterminateAttributes = indeterminate
        ? { 'indeterminate': 'true', 'aria-checked': 'mixed' }
        : { 'aria-checked': checked };
    return (react_1.default.createElement("div", __assign({ className: CheckboxClasses, onClick: handleClickEvent, ref: itemRef }, rest),
        react_1.default.createElement("label", { className: "Checkbox__html-label", ref: labelRef },
            react_1.default.createElement("input", __assign({ tabIndex: tabIndex, checked: checked, className: "Checkbox__input", disabled: disabled, id: id, name: name, onChange: onChangeHandler, onClick: onClickHandler, role: "checkbox", type: "checkbox" }, indeterminateAttributes)),
            react_1.default.createElement("span", { className: "Checkbox__box" }),
            getLabel())));
});
//# sourceMappingURL=Checkbox.js.map